import { lazy } from 'react';

const AdTags = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Layout: lazy(() => import('./containers/AdTags/components/AdTagsLayout.tsx')),
  Table: lazy(() => import('./containers/AdTags/containers/AdTagsTable/index.tsx')),
  ThirdPartyTagForm: lazy(() => import('./containers/AdTags/modules/ThirdPartyTagForm/index.tsx')),
  ThirdPartyWebsites: lazy(() => import('./containers/AdTags/containers/ThirdPartyWebsites/index.tsx')),
};

export default AdTags;
